
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make-your-w2",
      function () {
        return require("private-next-pages/make-your-w2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make-your-w2"])
      });
    }
  